
import { defineComponent, computed } from 'vue';
import Button from 'primevue/button';
import Card from 'primevue/card';
import ProgressSpinner from 'primevue/progressspinner';
import { formatCurrency } from '../../utils/currency';
import { CustomerGameDetail } from '../../types/customer';

export interface WithdrawDetail {
	label: string;
	amount: number;
	btnLabel: string;
	btnDisabled: boolean;
	btnLoading: boolean;
	btnTooltip: string;
	details: CustomerGameDetail[];
	loading: boolean;
	active: boolean;
}

export default defineComponent({
	name: 'CardWithdraw',
	methods: { formatCurrency },
	components: {
		Card,
		Button,
		ProgressSpinner,
	},
	props: {
		detail: {
			type: Object as () => WithdrawDetail,
			default: () => ({
				label: 'กระเป๋า',
				amount: 0.01,
				btnLabel: 'ถอน',
				btnDisabled: false,
				btnLoading: false,
				btnTooltip: '',
				details: [],
				loading: false,
				active: false,
			}),
		},
	},
	emits: ['withdraw'],
	setup(props, { emit }) {
		const isLoading = computed(() => props.detail.loading);
		const isActive = computed(() => props.detail.active);

		const handleWithdraw = () => {
			emit('withdraw');
		};

		return {
			isLoading,
			isActive,
			handleWithdraw,
		};
	},
});
